





export const ColumnSize = Object.freeze({
  ONE_COLUMN: 1,
  TWO_COLUMN: 2
});

export const ModuleType = Object.freeze({
  IMAGE: 'modules-image',
  TITLE: 'modules-title',
  TEXT: 'modules-text',
  VIDEO: 'modules-video',
  DIVIDER: 'modules-divider',
  BUTTON_GROUP: 'modules-button-group'
});

export const VideoMode = Object.freeze({
  SHOOTSTA_PLAYER: 'shootsta-player',
  PLAYER_CONTROLS: 'player-controls',
  PLAYER_NO_CONTROLS: 'player-no-controls'
});